module.exports = "<span>\r\n  {{ $ctrl.retailerId | retailerIdFormat }}\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-retailer-id/rw-retailer-id.html
// module id = 1919
// module chunks = 0